import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-title.svg'
import _imports_1 from '@/assets/logo-symbol.svg'


const _withScopeId = n => (_pushScopeId("data-v-1b0b6202"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-background" }, null, -1))
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-text",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-symbol",
  src: _imports_1
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "themes" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "switch",
  for: "theme-button"
}, null, -1))
const _hoisted_10 = { class: "account" }
const _hoisted_11 = {
  key: 0,
  class: "logged-in-container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "새 글 작성", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "시작하기", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_notification_list_button = _resolveComponent("notification-list-button")!
  const _component_account_summary_menu_button = _resolveComponent("account-summary-menu-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _ctx.clearCachedMainPosts
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("input", {
          id: "theme-button",
          type: "checkbox",
          checked: _ctx.isDarkTheme,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
        }, null, 40, _hoisted_8),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_notification_list_button),
              _createVNode(_component_router_link, { to: "/write" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_account_summary_menu_button)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_router_link, { to: "/signin" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]))
      ])
    ])
  ], 64))
}